import { all, fork } from 'redux-saga/effects';

// sagas
import enquireModalSaga from '../components/EnquireModal/sagas';

export default function* rootSaga() {
  yield all([fork(enquireModalSaga)]);
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/sagas/index.js